// extracted by mini-css-extract-plugin
module.exports = {"TransCap":"TransCap_TransCap__dB3Nu"};